import { playAddPersonSound } from './utils';
import { selectUser, selectRooms } from '../../../features/system';
export const onLeave = (uuid) => (dispatch) => {
    dispatch({
        type: 'PRESENCE/REMOVE_PERSON',
        payload: uuid,
    });
};
export const onStateUpdate = (person) => (dispatch) => {
    dispatch({
        type: 'PRESENCE/UPDATE_PERSON',
        payload: person,
    });
};
export const onJoin = (person, skipSound) => (dispatch, getState) => {
    if (!skipSound) {
        const user = selectUser(getState());
        const rooms = selectRooms(getState());
        playAddPersonSound(person, user, rooms);
    }
    dispatch({
        type: 'PRESENCE/ADD_PERSON',
        payload: person,
    });
};
export const forceRemove = (uuid) => (dispatch) => {
    dispatch({ type: 'PRESENCE/FORCE_REMOVE', payload: uuid });
};
export const clear = () => (dispatch) => {
    dispatch({ type: 'PRESENCE/CLEAR' });
};
